<nav aria-label="Breadcrumbs" data-bspk="breadcrumb">
  <ol>
  @for (item of items(); track $index) {
    <li>
      @if ($last) {
        <span bspk-txt="body-base">{{item.label}}</span>
      }
      @else {
        <a bspk-txt="labels-base" [routerLink]="item.href">{{item.label}}</a>
        <bspk-icon aria-hidden name="ChevronRight" />
      }
    </li>
  }
  </ol>
</nav>
